export const lowerCase = (string) => String(string).toLowerCase();
